import { addWeeks, findClosestWeekendDay, isDateAfter, isInFirstWeekOfYear } from '@lx/shared/utils';
import { ProductAccommodation } from '@lx/shared/data-access/products';
import { AccommodationAvailability } from '../types';

export function removeDuplicateAccommodations(accommodationList: ProductAccommodation[]): ProductAccommodation[] {
  return accommodationList?.reduce((uniqueAccommodations: ProductAccommodation[], accommodation: ProductAccommodation) => {
    if (!uniqueAccommodations.some((item) => item.code === accommodation.code)) {
      uniqueAccommodations.push(accommodation);
    }
    return uniqueAccommodations;
  }, []);
}

export function calculateLimitedAccommodationMaxDateForSchoolYear(
  limitDateSchoolYear: Date,
  maxDate: Date,
  selectedDuration = 0,
  availability: AccommodationAvailability[] = [],
): Date {
  if (!limitDateSchoolYear) {
    return maxDate;
  }

  let newMaxDate = maxDate;
  const limitDateSchoolYearWithDuration = addWeeks(limitDateSchoolYear, -selectedDuration);
  if (isDateAfter(maxDate, limitDateSchoolYearWithDuration)) {
    newMaxDate = limitDateSchoolYearWithDuration;
  }

  // if accommodation has an availability period, maxDate must respect it
  if (availability?.length) {
    const availabilityClosestSunday = findClosestWeekendDay(availability[0].until, 'sunday');
    const maxPeriodDate = addWeeks(availabilityClosestSunday, -selectedDuration);

    if (isDateAfter(newMaxDate, maxPeriodDate)) {
      newMaxDate = maxPeriodDate;
    }
  }

  return newMaxDate;
}

export function calculateLimitedMinDateForSchoolYear(
  limitMinDateSchoolYear: Date,
  limitMaxDateSchoolYear: Date,
  minDate: Date,
  firstSelectedCourseStartDate: Date,
): Date {
  if (!limitMinDateSchoolYear || (firstSelectedCourseStartDate && isInFirstWeekOfYear(firstSelectedCourseStartDate))) {
    return minDate;
  }

  const initialDate = isDateAfter(limitMinDateSchoolYear, minDate) ? limitMinDateSchoolYear : minDate;
  return isDateAfter(initialDate, limitMaxDateSchoolYear) ? limitMaxDateSchoolYear : initialDate;
}
